import styled from "styled-components";

export const MainContainer = styled.div<{ $controlSize?: "n" | "sm" | "xsm" }>`
	font-size: 1.2rem;
	border-radius: 4px;
	height: 30px;
	width: 100%;
	border: none;
	position: relative;

	${({ $controlSize }) => $controlSize === "sm" && "padding: 4.5px 1.5px 4.5px 3px !important;"}
`;

export const DatePickerWrapper = styled.div<{ $isError: boolean }>`
	input {
		font-size: 1.2rem;
		padding: 7px;
		border-radius: 4px;
		height: 30px;
		width: 100%;

		&:disabled {
			background-color: #f9f9f9;
			opacity: 0.5;
		}

		color: ${({ theme }) => theme.colors.textInput};
		background-color: ${({ theme }) => theme.colors.backgroundInput};
		border: 1px solid ${({ theme, $isError }) => (!$isError ? theme.colors.inputBorder : theme.colors.inputError)};

		&:focus {
			outline: 1px solid ${({ theme }) => theme.colors.inputBorderFocused};
		}

		&::placeholder {
			color: ${({ theme }) => theme.colors.inputPlaceholder};
		}
	}

	.calendarStyle {
		font-size: 10px;
	}

	.react-datepicker__header {
		background-color: #000000;
		padding: 0px;
		padding-bottom: 7px;
	}

	.react-datepicker__day-names {
		background-color: #f9fafb;
	}

	.react-datepicker__day-name {
		padding-top: 5px;
		font-size: 11px;
		height: 26px;
		width: 32px;
		color: #8f95b2;
	}

	.react-datepicker__current-month {
		color: whitesmoke;
		font-size: 12px;
		padding: 9px !important;
	}

	.react-datepicker__navigation {
		scale: 0.6;
		top: 0px;
	}

	.react-datepicker__day {
		padding-top: 5px;
		font-size: 11px;
		height: 26px;
		width: 32px;
	}

	.react-datepicker__today-button {
		font-size: 12px;
		background-color: #000000;
		color: whitesmoke;
	}

	.react-datepicker__day:hover {
		background-color: #75757553 !important;
	}

	.react-datepicker__day--in-range {
		background-color: #edeef4 !important;
		outline: 1px solid #c0c0c0;
		color: #212121;
		font-weight: 600 !important;
	}

	.react-datepicker__day--today {
		background-color: #e3e3ec !important;
		transition: 200ms;
		font-weight: normal;
	}

	.react-datepicker__month-container {
		float: none !important;
	}

	.react-datepicker__month {
		margin: 0 !important;
	}

	.react-datepicker__day--in-range:hover,
	.react-datepicker__day--in-selecting-range {
		background-color: #edeef4 !important;
		color: #212121;
	}

	.react-datepicker__day--selected {
		background-color: #edeef4;
		outline: 1px solid #c0c0c0;
		font-weight: 600;
		color: #212121;
	}

	.react-datepicker__day--keyboard-selected {
		background-color: transparent;
	}

	.react-datepicker__day--disabled:hover {
		background-color: transparent !important;
		cursor: pointer;
	}
`;

export const CalendarIconContainer = styled.div`
	position: absolute;
	pointer-events: none;
	right: 10px;
	cursor: pointer;
	top: 50%;
	transform: translate(0, -50%);
`;
